module.exports = __webpack_public_path__ + "static/media/kick.97d0c890.mp3";